
import rootScope from "./rootScope";
import $ from "./$";
import map from "./map";
import Evented from "./Evented";


function panToOffset(y, lat, lon) {
    const zoom = map.getZoom()
        , sizey = map.getSize().y
        , projectedCoords = map.project([lat, lon], zoom).subtract([0, y - sizey / 2])
        , unProjectedCoords = map.unproject(projectedCoords, zoom);
    map.setView(unProjectedCoords, zoom, {
        animate: false
    })
}


class PickerDot {

    constructor() {
        this.lat=null;
        this.lon=null;
        // if (rootScope.isMobileOrTablet) {
            this.mapContainerEl = $("#map-container");
            this.pickerDotEl = $("#picker-dot");
            map.on("resize", this.positionChanged.bind(this));
        // }
    }

    lockPosition() {
        const coords = this.getLatLng();
        this.lat = coords.lat;
        this.lon = coords.lon;
    }


    unlockPosition() {
        this.lat = null;
        this.lon = null;
    }

    setPosition(lat, lon) {
        panToOffset(this.getDotPosition().y, lat, lon);
        this.lat = lat;
        this.lon = lon;
    }


    offsetPosition(e) {
        this.mapContainerEl.style.transform = e > 0 ? "translateY(-".concat(Math.floor(e / 2), "px)") : "none"
    }


    resetOffset() {
        this.offsetPosition(0)
    }

    getLatLng() {
        const pos = this.getDotPosition()
            , x = pos.x
            , y = pos.y;
        return map.containerPointToLatLng([x, y])
    }


    getDotPosition() {
        return {
            x: this.pickerDotEl.offsetLeft + this.pickerDotEl.offsetWidth / 2,
            y: this.pickerDotEl.offsetTop + this.pickerDotEl.offsetHeight / 2
        }
    }

    positionChanged() {
        if(null !== this.lat && null !== this.lon)
            this.setPosition(this.lat, this.lon)
    }

}

let emitter = Evented.instance({
    ident: "picker"
});


const pickerDot = new PickerDot();

export default {
    PickerDot: PickerDot,
    emitter: emitter,
    pickerDot: pickerDot
};
